import script from "./sf-modal-portal.vue?vue&type=script&setup=true&lang=ts&generic=ID%20extends%20ModalPortalIdentifier"
export * from "./sf-modal-portal.vue?vue&type=script&setup=true&lang=ts&generic=ID%20extends%20ModalPortalIdentifier"

const __exports__ = script;

export default __exports__